import { HOST_QUERY_KEY, iamApiInstance, type ServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { commonGuardErrorHandler } from '../../utils/commonGuardErrorHandler';

import type { Guard } from '../../types';

/**
 * 접근 가능한 프로젝트 목록을 얻는 가드
 * @description
 * - 사용자가 접근 가능한 프로젝트 목록을 iam에 요청하여 얻는 가드입니다.
 * - GNB의 프로젝트 선택 UI를 위해서 필요한 가드입니다.
 */
export const determineAccessibleProjectGuard: Guard<ServiceAppState> = async ({
  queryClient,
  state,
  context,
}) => {
  const { token = '', userId = '' } = state;
  const { fetchProjects } = iamApiInstance({ token });

  try {
    const accessibleProjects = await queryClient.fetchQuery({
      queryKey: [HOST_QUERY_KEY.GET_IAM_ACCESSIBLE_PROJECT_LIST],
      queryFn: () => fetchProjects({ userId }),
    });

    return { status: STATUS_CODE.OK, accessibleProjects };
  } catch (error) {
    return commonGuardErrorHandler({
      context,
      state,
      error,
    });
  }
};

determineAccessibleProjectGuard.displayName = 'determineAccessibleProjectGuard';
determineAccessibleProjectGuard.traceCategory = 'authorization';
